import { Box, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};
const RegisterModal = ({ open, setOpen }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          maxWidth: "75%",
          overflowY: "hidden",
          overflowX: "wrap",
          maxHeight: "80vh",
          padding: 0,
        }}
        className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
      >
        <p className="text-[20px] font-bold px-8 pt-4">Registrasi OLIN</p>
        <div className="px-8 pt-4 pb-2">
          <p className="text-blue-500 bg-blue-100 rounded-md p-2 mb-2">
            OLIN bekerjasama dengan PT Millennium Pharmacon International (MPI)
            sebagai distributor produk pharma
          </p>
        </div>
        <div className="px-8 pb-4 flex gap-4 items-stretch justify-center">
          <div
            className={`h-full w-full border-2 rounded-md p-4 border-green-500 flex flex-col items-stretch justify-between`}
          >
            <div className="text-[16px] font-semibold mb-3 flex justify-between items-center">
              <p>Relasi MPI</p>
            </div>
            <p className="mb-2">
              Jika anda pernah melakukan transaksi di MPI atau sudah menjadi
              relasi MPI, Anda dapat menambahkan akun disini
            </p>
            <div className="flex justify-end">
              <button
                className="bg-green-100 text-green-500 hover:bg-gray-300 hover:text-white rounded-md py-2 px-4 w-fit"
                type="button"
                onClick={() => navigate(`/register/mpi`)}
              >
                Buat Akun
              </button>
            </div>
          </div>
          <div
            className={`self-stretch h-auto w-full border-2 rounded-md p-4 flex flex-col items-stretch justify-between ${
              true ? "border-blue-500" : "bg-gray-200 cursor-default"
            }`}
          >
            <div className="text-[16px] font-semibold mb-3 flex justify-between items-center">
              <p>Non Relasi MPI</p>
            </div>
            <p>
              Gabung & daftarkan Apotek Anda sebagai relasi MPI di dalam
              Platform OLIN dan digitalisasi Apotek Anda
            </p>
            <div className="flex justify-end">
              <button
                className="bg-blue-100 text-blue-500 disabled:bg-gray-300 disabled:text-white hover:bg-gray-300 hover:text-white rounded-md py-2 px-4 w-fit"
                type="button"
                onClick={() => navigate(`/register/new-pharmacy`)}
              >
                Daftar Relasi
              </button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default RegisterModal;
